import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';

import { NCRContext } from 'views';

import { FormDatePicker } from 'components/form/prototypes';

const ApprovedDate = () => {

  const { state } = useContext(NCRContext);
  const { control, register } = useFormContext();

  const isDisabled = true;

  return (
    <FormDatePicker
      label='Date Approved'
      name='ncr.approved_date'
      control={control}
      register={register}
      selectedDate={state.ncr.approved_date ? new Date(state.ncr.approved_date) : ''}
      showTime
      disabled={isDisabled}
    />
  )
}

export { ApprovedDate };
